import styles from './List.css'
import {connect} from 'react-redux'
import InfiniteScroll from 'react-infinite-scroller'
import {isDirty} from 'redux-form'
import * as actIngredientLibrary from 'actions/ingredients/library'
import {askConfirmAction} from 'actions/confirm-action'

class List extends React.Component {
  render () {
    let {libraries, libraryDetail} = this.props

    return (<div className={styles['wrapper']}>
      {libraries.length > 0 &&
        <div className={styles['full-height']}>
          <div className={`${styles['leftcol']} no-padding`} id='mk-col-left'>
            <table className={styles['table-header']}>
              <thead>
                <tr>
                  <th className={`${styles.headerName} text-left`}>Name</th>
                  <th className={`${styles.headerCategory} text-left`}>Category</th>
                  <th className={`${styles.headerInStock} text-left`}>In Stock</th>
                  <th className={`${styles.headerUnit} text-left`}>Unit</th>
                  <th className={`${styles.headerStockAlert} text-center`}>Stock Alert</th>
                </tr>
              </thead>
            </table>
            <div className={styles['table-content-wrapper']}>
              <InfiniteScroll
                pageStart={1}
                loadMore={this._onReachBottom}
                hasMore={this._hasMore()}
                useWindow={false}
                threshold={10}
                initialLoad={false}>
                <table className={styles['table-content']}>
                  <tbody>
                    {libraries.length > 0 && libraries.map((library) => {
                      return (<tr className={`${(libraryDetail && libraryDetail.id === library.id) ? styles.selected : ''}`}
                        onClick={() => this._onClickRow(library)}>
                        <td className={styles.headerName}>{library.name}</td>
                        <td className={styles.headerCategory}>{library.category_name}</td>
                        <td className={styles.headerInStock}>{library.in_stock}</td>
                        <td className={styles.headerUnit}>{library.unit_name}</td>
                        <td className={styles.headerStockAlert}>{this._stockAlertFormatter(library)}</td>
                      </tr>)
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            </div>
          </div>
        </div>
      }
    </div>)
  }

  _onClickRow = (library) => {
    const {isDirtyItem} = this.props
    if (isDirtyItem) {
      this.props.dispatch(askConfirmAction(actIngredientLibrary.onClickRow(library)))
    } else {
      this.props.dispatch(actIngredientLibrary.onClickRow(library))
    }
  };

  _onReachBottom = () => {
    let {dispatch, currentPage, libraries, filterState} = this.props
    dispatch(actIngredientLibrary.librariesRequest({page: currentPage + 1, filterState}, libraries))
  };

  _hasMore = () => {
    let {currentPage, totalPage} = this.props
    return currentPage < totalPage
  }

  _stockAlertFormatter = (ingredient) => {
    let result = {status: '', color: ''}
    if (ingredient.stock_alert >= ingredient.in_stock && ingredient.in_stock > 0 && ingredient.alert) {
      result = {status: 'Low', className: 'low-stock'}
    } else if (ingredient.in_stock <= 0 && ingredient.alert) {
      result = {status: 'Out', className: 'out-stock'}
    }
    return <span className={result.className}>{result.status}</span>
  }
}

function mapStateToProps (state) {
  let {libraries, libraryDetail, currentPage, totalPage, showDetail, filterState} = state.ingredients.library
  return {
    libraries,
    libraryDetail,
    currentPage,
    totalPage,
    showDetail,
    isDirtyItem: isDirty('library')(state),
    filterState
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

List.propTypes = {
  dispatch: React.PropTypes.func,
  libraries: React.PropTypes.array,
  libraryDetail: React.PropTypes.object,
  currentPage: React.PropTypes.number,
  totalPage: React.PropTypes.number,
  showDetail: React.PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/List/List.js